import { render, staticRenderFns } from "./CardTarjaVoceDecide.vue?vue&type=template&id=b810afb8&scoped=true"
import script from "./CardTarjaVoceDecide.vue?vue&type=script&lang=js"
export * from "./CardTarjaVoceDecide.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaVoceDecide.vue?vue&type=style&index=0&id=b810afb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b810afb8",
  null
  
)

export default component.exports